import request from '../../../helpers/request';

const addAccount = async (values, accountName) => {
  const response = await request.put(
    `/HousingStock/account`,
    values,
    `При добавлении лицевого счета ${accountName} произошла ошибка`
  );

  return response;
};

export default addAccount;
